import { render, staticRenderFns } from "./FinancialCategories.vue?vue&type=template&id=e0449154&scoped=true"
import script from "./FinancialCategories.vue?vue&type=script&lang=js"
export * from "./FinancialCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0449154",
  null
  
)

export default component.exports